import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";

const FiatAddressUpdate = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [formData, setFormData] = useState({
        FiatEvmAdminWallet: "",
        FiatTronAdminWallet: "",
        FiatbtcAdminWallet: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const fetchFiatWallets = async () => {
        try {
            setIsLoading(true);

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/admin/get-platform-fee`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            if (response.status === 200) {
                const data = response?.data?.data;

                setFormData({
                    FiatEvmAdminWallet: data?.FiatEvmAdminWallet || "",
                    FiatTronAdminWallet: data?.FiatTronAdminWallet || "",
                    FiatbtcAdminWallet: data?.FiatbtcAdminWallet || "",
                });
            }
        } catch (error) {
            console.error("Error fetching fiat wallets:", error);
            toast.error("Failed to load fiat wallet addresses");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setIsLoading(true);

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/admin/update-fiat-wallet`,
                {
                    FiatEvmAdminWallet: formData.FiatEvmAdminWallet,
                    FiatTronAdminWallet: formData.FiatTronAdminWallet,
                    FiatbtcAdminWallet: formData.FiatbtcAdminWallet,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            if (response.status === 201) {
                toast.success("Fiat wallet addresses updated successfully");
            }
        } catch (error) {
            console.error("Error updating fiat wallets:", error);
            toast.error("Failed to update fiat wallet addresses");
        } finally {
            setIsLoading(false);
        }
    };

    // ✅ Page load par auto-fetch
    useEffect(() => {
        fetchFiatWallets();
    }, []);

    if (isLoading) return <Loader />;

    return (
        <div className="col-md-12 mt-4">
            <div className="card card-primary">
                <form onSubmit={handleSubmit}>
                    <div
                        className="card-header"
                        style={{
                            position: "relative",
                        }}
                    >
                        {/* Title (default center/left jo template kare) */}
                        <h3 className="card-title mb-0">Fiat Admin Wallet Management</h3>

                        {/* Right-aligned Hover Icon */}
                        <span
                            title="These admin wallet addresses are used for FIAT transaction settlements on EVM, TRON, and BTC networks."
                            style={{
                                position: "absolute",
                                right: "20px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#0d6efd",
                                fontSize: "16px",
                            }}
                        >
                            <i className="bi bi-info-circle"></i>
                            {/* or use ⓘ if icons not loaded */}
                        </span>
                    </div>

                    <div className="card-body">
                        <div className="row">
                            {/* EVM */}
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Fiat EVM Admin Wallet</label>
                                    <input
                                        type="text"
                                        name="FiatEvmAdminWallet"
                                        className="form-control"
                                        value={formData.FiatEvmAdminWallet}
                                        onChange={handleChange}
                                        placeholder="0x..."
                                    />
                                </div>
                            </div>

                            {/* TRON */}
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Fiat TRON Admin Wallet</label>
                                    <input
                                        type="text"
                                        name="FiatTronAdminWallet"
                                        className="form-control"
                                        value={formData.FiatTronAdminWallet}
                                        onChange={handleChange}
                                        placeholder="T..."
                                    />
                                </div>
                            </div>

                            {/* BTC */}
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Fiat BTC Admin Wallet</label>
                                    <input
                                        type="text"
                                        name="FiatbtcAdminWallet"
                                        className="form-control"
                                        value={formData.FiatbtcAdminWallet}
                                        onChange={handleChange}
                                        placeholder="bc1..."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer text-center">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isLoading}
                            style={{
                                opacity: isLoading ? 0.7 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Updating...
                                </>
                            ) : (
                                'Set Fiat Wallet Addresses'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FiatAddressUpdate;
